import styled, { css } from 'styled-components'
import { tokens } from 'styling/tokens'

export const TasksTabsContainer = styled.div<{ noMargin?: boolean }>`
  margin: ${(props) => (props.noMargin ? '0' : '0 1rem')};
  max-width: 50%;
  display: flex;
  align-items: center;
  gap: 1rem;
  z-index: 999999;
  margin-right: 1rem;
  -ms-overflow-style: none;
  scrollbar-width: none;
  position: relative;
  ::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
  @media (max-width: 1370px) {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
`

export const TaskTabsArrow = styled.div`
  height: 100%;
  background-color: ${tokens.surface.raised};
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: 9999999999999900;
  svg {
    transform: rotate(-90deg) scale(2);
  }
`

interface ITaskTabsProps {
  active: boolean
  adaptWidth?: boolean
}

export const TasksTabs = styled.div<ITaskTabsProps>`
  background: ${tokens.surface.inset} !important;
  min-width: ${(props) => (props.adaptWidth ? '7rem' : '10rem')};
  cursor: pointer;
  font-size: 0.8rem;
  position: relative;
  box-sizing: border-box;
  user-select: none;
  border-radius: 0.5rem;
  color: ${(props) => (props.active ? tokens.accent.base : tokens.text.primary)};
  font-weight: ${(props) => (props.active ? 'bold' : '400')};
  height: 2.5rem;
  border: ${(props) => (props.active ? '1px solid ' + tokens.accent.base : '1px solid ' + tokens.text.secondary)};
  transition: all 0.2s;
  opacity: ${(props) => (props.active ? '1' : '0.5')};
  z-index: 99999999999999;
  box-shadow: ${(props) => (!props.active ? 'none' : tokens.shadow.card)};
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    color: ${tokens.accent.base};
    border: 1px solid ${tokens.accent.base};
    opacity: 1;
  }
`

export const TasksLogicTabContainer = styled.div`
  width: 100%;
  min-height: 500px;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  ${(props) => props.theme.container}
`

export const TaskLogicCanvas = styled.div`
  flex: 1;
  min-width: 0;
  width: 100%;
  height: 100%;
  min-height: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  ${(props) => props.theme.container};
  overflow: hidden;

  .react-flow {
    width: 100%;
    height: 100%;
    flex: 1;
  }

  .react-flow__background {
    background: ${tokens.surface.raised};
  }

  .react-flow__attribution {
    display: none;
  }

  .react-flow__edge-path {
    stroke-width: 2;
  }

  .react-flow__edge.selected .react-flow__edge-path {
    stroke-width: 3;
  }

  .react-flow__handle {
    width: 10px;
    height: 10px;
    background: ${tokens.accent.base};
    border: 2px solid ${tokens.surface.raised};
  }

  .react-flow__handle-left {
    left: 0;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .react-flow__handle-right {
    left: auto;
    right: 0;
    top: 50%;
    transform: translate(50%, -50%);
  }

  .react-flow__node {
    overflow: visible;
  }

  .react-flow__controls {
    box-shadow: ${tokens.shadow.card};
    border-radius: 8px;
    overflow: hidden;
  }

  .react-flow__controls-button {
    background: ${tokens.surface.raised};
    border-bottom: 1px solid ${tokens.border.hairline};

    svg {
      fill: ${tokens.text.primary};
    }
  }

  .react-flow__controls-button:hover {
    background: ${tokens.surface.inset};
  }
`

export const TaskLogicToolbar = styled.div`
  position: absolute;
  top: 1rem;
  left: 1rem;
  z-index: 5;
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem;
  border-radius: ${tokens.radius.control};
  box-shadow: ${tokens.shadow.card};
`

export const TaskLogicEmptyHint = styled.div<{ visible: boolean }>`
  position: absolute;
  inset: 0;
  display: ${(props) => (props.visible ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  pointer-events: none;
  color: ${tokens.text.primary};
  opacity: 0.55;
  font-size: 0.875rem;
  z-index: 1;
`

export const InputComponentNodeBox = styled.div<{ selected?: boolean }>`
  width: 160px;
  min-height: 56px;
  padding: 0.6rem 0.9rem;
  background: ${tokens.accent.base};
  border-radius: ${tokens.radius.card};
  box-shadow: ${tokens.shadow.card};
  color: ${tokens.accent.ink};
  font-size: 0.85rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
  transition: box-shadow 0.15s ease, transform 0.15s ease;

  ${(props) =>
    props.selected &&
    css`
      box-shadow: ${tokens.shadow.card};
    `}

  &:hover {
    box-shadow: ${tokens.shadow.card};
  }
`

export const CalcComponentNodeBox = styled.div<{ selected?: boolean; wired?: boolean }>`
  width: 160px;
  min-height: 56px;
  padding: 0.6rem 0.9rem;
  background: ${tokens.surface.raised};
  color: ${tokens.text.primary};
  border-radius: ${tokens.radius.card};
  box-shadow: ${tokens.shadow.card};
  font-size: 0.85rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
  border: 1px solid ${tokens.border.hairline};
  transition: box-shadow 0.15s ease, border-color 0.15s ease, transform 0.15s ease;

  ${(props) =>
    props.wired &&
    css`
      border-color: ${tokens.accent.base};
    `}

  ${(props) =>
    props.selected &&
    css`
      box-shadow: ${tokens.shadow.card};
      border-color: ${tokens.accent.base};
    `}

  &:hover {
    box-shadow: ${tokens.shadow.card};
  }
`

export const FunctionNodeBox = styled.div<{ selected?: boolean; connected?: boolean }>`
  width: 220px;
  background: ${tokens.surface.raised};
  color: ${tokens.text.primary};
  border-radius: ${tokens.radius.card};
  box-shadow: ${tokens.shadow.card};
  border: 1px solid ${tokens.border.hairline};
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: visible;
  transition: box-shadow 0.15s ease, border-color 0.15s ease;

  ${(props) =>
    props.connected &&
    css`
      border-color: ${tokens.accent.base};
    `}

  ${(props) =>
    props.selected &&
    css`
      box-shadow: ${tokens.shadow.card};
      border-color: ${tokens.accent.base};
    `}

  &:hover {
    box-shadow: ${tokens.shadow.card};
  }
`

export const FunctionNodeTitle = styled.div`
  padding: 0.6rem 0.9rem 0.5rem;
  font-size: 0.85rem;
  font-weight: 600;
  text-align: center;
  word-break: break-word;
  border-bottom: 1px solid ${tokens.border.hairline};
`

export const FunctionPortsRow = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.4rem 0;
`

export const FunctionPort = styled.div<{ side: 'left' | 'right' }>`
  position: relative;
  padding: 0.35rem 0.9rem;
  font-size: 0.72rem;
  color: ${tokens.text.primary};
  text-align: ${(props) => (props.side === 'left' ? 'left' : 'right')};
  overflow: visible;
`

export const FunctionPortLabel = styled.span`
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const FunctionPortGroupLabel = styled.div`
  font-size: 0.62rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${tokens.text.primary};
  opacity: 0.55;
  padding: 0 0.9rem;
  margin-top: 0.25rem;
`

export const TaskNodeDeleteBtn = styled.button`
  position: absolute;
  top: 4px;
  right: 4px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: ${tokens.surface.raised};
  border: 1px solid ${tokens.border.hairline};
  color: ${tokens.text.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease, transform 0.15s ease;
  z-index: 2;

  svg {
    width: 12px;
    height: 12px;
  }

  &:hover {
    background: ${tokens.status.danger.fg};
    border-color: ${tokens.status.danger.fg};
    color: ${tokens.text.primary};
    transform: scale(1.05);
  }

  &:hover svg path {
    stroke: ${tokens.text.primary};
  }
`

export const TaskLogicEdgeDeleteButton = styled.button<{ show?: boolean }>`
  position: absolute;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: ${tokens.surface.raised};
  color: ${tokens.text.primary};
  border: 1.5px solid ${tokens.accent.base};
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: all;
  box-shadow: ${tokens.shadow.card};
  opacity: ${(props) => (props.show ? 1 : 0)};
  transition: opacity 0.15s ease, background 0.15s ease, color 0.15s ease;

  &:hover {
    background: ${tokens.accent.base};
    color: ${tokens.accent.ink};
  }
`
